function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["time"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { DictRadioButton } from "../../components/Form/Radio";
import Search from "../../components/Form/Search";
import Suggest, { DictSuggest } from "../../components/Form/Suggest";
import { DictText } from "../../components/Form/Text";
import PageTitle from "../../components/Layout/PageTitle";
import { useImportTalentModal } from "../../components/ImportFile";
import { Button, DatePicker, Input, Space, Table } from 'antd';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from "./index.module.css";
import { useData } from "./state";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var List = function List() {
  var openImportTalentModal = useImportTalentModal();
  var _useData = useData(),
    _useData$data = _useData.data,
    tableData = _useData$data.tableData,
    selectedRowKeys = _useData$data.selectedRowKeys,
    selectedNum = _useData$data.selectedNum,
    search = _useData$data.search,
    _useData$action = _useData.action,
    tableAction = _useData$action.tableAction,
    multiExport = _useData$action.multiExport,
    onRowSelectionChange = _useData$action.onRowSelectionChange;
  useEffect(function () {
    document.addEventListener('visibilitychange', refetch);
    return function () {
      document.removeEventListener('visibilitychange', refetch);
    };
  }, []);
  var refetch = function refetch() {
    if (document.visibilityState === 'visible') {
      tableAction.refetch();
    }
  };
  var _tableData$pagination = tableData.pagination,
    pagination = _tableData$pagination === void 0 ? {} : _tableData$pagination,
    dataSource = tableData.data;
  var _pagination$total = pagination.total,
    total = _pagination$total === void 0 ? 0 : _pagination$total;
  var columns = [{
    title: '序号',
    dataIndex: 'orderCode',
    width: 45,
    align: 'center',
    render: function render(a, b, i) {
      return i + 1;
    }
  }, {
    title: '订单编号',
    dataIndex: 'orderCode'
  }, {
    title: '采购申请单号',
    dataIndex: 'sourceOrderCode'
  }, {
    title: '金蝶采购单号',
    dataIndex: 'thirdCode'
  }, {
    title: '订货日期',
    dataIndex: 'purchaseDate'
  }, {
    title: '到货日期',
    dataIndex: 'arrivalDate'
  }, {
    title: '收货门店',
    dataIndex: 'shopName'
  }, {
    title: '供应商',
    dataIndex: 'supplierName'
  }, {
    title: '配送方式',
    dataIndex: 'dispatchMethod',
    render: function render(val) {
      return /*#__PURE__*/_jsx(DictText, {
        dictType: "scm_delivery_type",
        value: val
      });
    }
  }, {
    title: '仓库',
    dataIndex: 'virtualWhName'
  }, {
    title: '三方物流服务商',
    dataIndex: 'logisticsServiceName'
  }, {
    title: '总金额',
    dataIndex: 'totalAmount',
    align: 'right',
    render: function render(v, r) {
      return r.showPrice ? v === undefined ? '-' : "\uFFE5".concat(v) : '-';
    }
  }, {
    title: '不含税总金额',
    dataIndex: 'totalNoTaxAmount',
    align: 'right',
    render: function render(v, r) {
      return r.showPrice ? v === undefined ? '-' : "\uFFE5".concat(v) : '-';
    }
  }, {
    title: '品项种类',
    dataIndex: 'itemCount',
    align: 'right'
  }, {
    title: '是否定制品',
    dataIndex: 'customized',
    render: function render(v) {
      return /*#__PURE__*/_jsxs("div", {
        className: styles.customized,
        children: [/*#__PURE__*/_jsx("div", {
          className: v === 2 ? styles.grayIcon : styles.redIcon
        }), /*#__PURE__*/_jsx(DictText, {
          dictType: "scm_is_customized",
          value: v
        })]
      });
    }
  }, {
    title: '订单状态',
    dataIndex: 'orderStatus',
    render: function render(value) {
      return /*#__PURE__*/_jsx(DictText, {
        value: value,
        dictType: "scm_purchase_order_status"
      });
    }
  }, {
    title: '配送状态',
    dataIndex: 'dispatchStatus',
    render: function render(value) {
      return /*#__PURE__*/_jsx(DictText, {
        value: value,
        dictType: "scm_purchase_order_dispatch_status"
      });
    }
  }, {
    title: '单据类型',
    dataIndex: 'businessType',
    render: function render(value) {
      return /*#__PURE__*/_jsx(DictText, {
        value: value,
        dictType: "scm_request_order_business_type"
      });
    }
  }, {
    title: '当前节点',
    dataIndex: 'currentNodeName'
  }, {
    title: '当前处理人',
    dataIndex: 'approver',
    render: function render(value, record) {
      //TODO:: 有可能人很多，需要..。和查看更多
      return /*#__PURE__*/_jsx("div", {
        children: value
      });
    }
  }, {
    title: '操作',
    fixed: 'right',
    render: function render(value, record) {
      return /*#__PURE__*/_jsx(Link, {
        to: "/Supply/Orders/Purchase/Detail?orderCode=".concat(record.orderCode),
        target: "_blank",
        children: /*#__PURE__*/_jsx("span", {
          className: styles.edit,
          children: "\u8BE6\u60C5"
        })
      });
    }
  }];
  return /*#__PURE__*/_jsxs("div", {
    className: styles.page,
    children: [/*#__PURE__*/_jsx(PageTitle, {
      children: "\u95E8\u5E97\u91C7\u8D2D\u5355"
    }), /*#__PURE__*/_jsx("div", {
      className: "form w-auto",
      children: /*#__PURE__*/_jsxs(Search, {
        ref: search,
        formContainer: styles.formContainer,
        labelCol: {
          className: styles.max70
        },
        onFinish: function onFinish(query) {
          console.log(query);
          var _query$time = query.time,
            time = _query$time === void 0 ? [] : _query$time,
            other = _objectWithoutProperties(query, _excluded);
          var _time = _slicedToArray(time, 2),
            startTime = _time[0],
            endTime = _time[1];
          tableAction.handleQueryChange(_objectSpread(_objectSpread({}, other), {}, {
            purchaseDate: {
              start: startTime ? dayjs(startTime).format('YYYY-MM-DD') : undefined,
              end: endTime ? dayjs(endTime).format('YYYY-MM-DD') : undefined
            }
          }));
        },
        children: [/*#__PURE__*/_jsx(Search.Field, {
          name: "orderStatus",
          label: "\u8BA2\u5355\u72B6\u6001",
          children: /*#__PURE__*/_jsx(DictSuggest, {
            placeholder: "\u8BF7\u9009\u62E9\u8BA2\u5355\u72B6\u6001",
            dictType: "scm_purchase_order_status"
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "dispatchMethod",
          label: "\u914D\u9001\u65B9\u5F0F",
          children: /*#__PURE__*/_jsx(DictSuggest, {
            placeholder: "\u8BF7\u9009\u62E9\u914D\u9001\u65B9\u5F0F",
            dictType: "scm_delivery_type"
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "dispatchStatus",
          label: "\u914D\u9001\u72B6\u6001",
          children: /*#__PURE__*/_jsx(DictSuggest, {
            placeholder: "\u8BF7\u9009\u62E9\u914D\u9001\u72B6\u6001",
            dictType: "scm_purchase_order_dispatch_status"
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "businessType",
          label: "\u5355\u636E\u7C7B\u578B",
          children: /*#__PURE__*/_jsx(DictSuggest, {
            placeholder: "\u8BF7\u9009\u62E9\u5355\u636E\u7C7B\u578B",
            dictType: "scm_request_order_business_type"
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "time",
          label: "\u8BA2\u5355\u65E5\u671F",
          children: /*#__PURE__*/_jsx(DatePicker.RangePicker, {
            style: {
              width: '100%'
            },
            format: "YYYY-MM-DD"
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "shopCode",
          label: "\u6536\u8D27\u95E8\u5E97",
          children: /*#__PURE__*/_jsx(Suggest, {
            url: "/finance/finance-fee/company/list",
            placeholder: "\u8BF7\u8F93\u5165\u7EC4\u7EC7\u67B6\u6784",
            requestFilter: function requestFilter(_ref) {
              var keyword = _ref.keyword;
              return {
                page: {
                  index: 1,
                  size: 10,
                  sorts: []
                },
                key: keyword
              };
            }
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "orderCode",
          label: "\u8BA2\u5355\u7F16\u53F7",
          children: /*#__PURE__*/_jsx(Input, {
            placeholder: "\u8BF7\u8F93\u5165\u8BA2\u5355\u7F16\u53F7"
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "skuKey",
          label: "\u5546\u54C1\u7F16\u7801/\u5546\u54C1\u540D\u79F0",
          children: /*#__PURE__*/_jsx(Input, {
            placeholder: "\u8BF7\u8F93\u5165\u5546\u54C1\u7F16\u7801/\u5546\u54C1\u540D\u79F0"
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "sourceOrderCode",
          label: "\u91C7\u8D2D\u7533\u8BF7\u5355\u53F7",
          children: /*#__PURE__*/_jsx(Input, {
            placeholder: "\u8BF7\u8F93\u5165\u91C7\u8D2D\u7533\u8BF7\u5355\u53F7"
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "thirdCode",
          label: "\u91D1\u8776\u91C7\u8D2D\u5355\u53F7",
          children: /*#__PURE__*/_jsx(Input, {
            placeholder: "\u8BF7\u8F93\u5165\u91D1\u8776\u91C7\u8D2D\u5355\u53F7"
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "supplierCode",
          label: "\u4F9B\u5E94\u5546",
          children: /*#__PURE__*/_jsx(Suggest, {
            url: "/erp/scm/supplier/suggest",
            placeholder: "\u8BF7\u9009\u62E9\u4F9B\u5E94\u5546",
            method: "get",
            requestFilter: function requestFilter(_ref2) {
              var keyword = _ref2.keyword;
              return {
                page: {
                  index: 1,
                  size: 100,
                  sorts: []
                },
                supplierNameLike: keyword
              };
            },
            usePage: false
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "currentNode",
          label: "\u5F53\u524D\u8282\u70B9",
          children: /*#__PURE__*/_jsx(DictSuggest, {
            placeholder: "\u8BF7\u9009\u62E9\u5F53\u524D\u8282\u70B9",
            dictType: "scm_purchase_order_flow_node"
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "customized",
          label: "\u662F\u5426\u8BA2\u5236\u54C1",
          children: /*#__PURE__*/_jsx(DictRadioButton, {
            showAll: true,
            defaultValue: "",
            dictType: "scm_is_customized"
          })
        }), /*#__PURE__*/_jsx(Search.Field, {
          name: "virtualWhCode",
          label: "\u4ED3\u5E93",
          children: /*#__PURE__*/_jsx(Suggest, {
            url: "/baseinfo/wh/virtualWhList",
            usePage: false,
            placeholder: "\u8BF7\u9009\u62E9\u4ED3\u5E93",
            autoSearch: true,
            showSearch: false,
            responseFilter: function responseFilter(data) {
              return data === null || data === void 0 ? void 0 : data.map(function (item) {
                return {
                  label: item.virtualWhName,
                  value: item.virtualWhCode
                };
              });
            }
          })
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.btContainer,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.totalContent,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.total,
          children: ["\u5171", total, "\u6761\u7ED3\u679C"]
        }), selectedNum ? /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.totalLine
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.total,
            children: ["\u5DF2\u9009", selectedNum, "\u9879"]
          })]
        }) : null]
      }), /*#__PURE__*/_jsxs(Space, {
        children: [/*#__PURE__*/_jsx(Button, {
          type: "primary",
          onClick: function onClick() {
            return openImportTalentModal({
              path: '/erp/scm/purchase/import/batch/send',
              betaUrl: 'https://micuntest-oss-bucket.oss-cn-beijing.aliyuncs.com/importTemplate/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E9%99%84%E4%BB%B6.xlsx',
              prodUrl: 'https://micun-oss-bucket.oss-cn-beijing.aliyuncs.com/importTemplate/%E6%89%B9%E9%87%8F%E5%8F%91%E8%B4%A7%E9%99%84%E4%BB%B6.xlsx'
            }).then(function () {
              tableAction.refetch();
            }).catch(function () {});
          },
          children: "\u6279\u91CF\u53D1\u8D27"
        }), /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return multiExport();
          },
          type: "primary"
          // disabled={selectedRowKeys.length === 0}
          ,
          children: "\u6279\u91CF\u5BFC\u51FA"
        })]
      })]
    }), /*#__PURE__*/_jsx(Table
    // bordered
    , {
      rowKey: "orderCode",
      size: "middle",
      rowSelection: {
        type: 'checkbox',
        selectedRowKeys: selectedRowKeys,
        onChange: onRowSelectionChange
      },
      columns: columns,
      scroll: {
        x: 'max-content'
      },
      loading: tableData.isLoading,
      pagination: _objectSpread(_objectSpread({}, pagination), {}, {
        total: (dataSource === null || dataSource === void 0 ? void 0 : dataSource.length) === 0 ? 0 : total,
        showSizeChanger: true,
        showQuickJumper: true
      }),
      dataSource: dataSource,
      onChange: tableAction.handleTableChange
    })]
  });
};
export default List;